import { Routes, Route } from 'react-router-dom';
import MarketingPage from './MarketingPage';
import AppShell from './components/AppShell';
import TermsOfUse from './TermsOfUse';
import Faq from './Faq';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<MarketingPage />} />
      <Route path="/app/*" element={<AppShell />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="/faq" element={<Faq />} />
    </Routes>
  );
}
